export function caluculateMeasuringFreq(freq) {
  return parseFloat((1.0 / freq).toFixed(2))
}



// WEBPACK FOOTER //
// ./src/utils/ferment.js